// extracted by mini-css-extract-plugin
export default {"n_nav":"NoticePrivacy_n_nav__hwst9","n_header":"NoticePrivacy_n_header__6WngW","n_cont":"NoticePrivacy_n_cont__DBUdf","n_line":"NoticePrivacy_n_line__Rd442"};